<template>
  <div class="button-group" :class="{ vertical: $vuetify.breakpoint.lgAndUp }">
    <button
      v-for="page in pages"
      :key="page"
      class="default-btn text" :class="{ active: page === activePage }"
      @click="$emit('selected', page)"
    >{{ page }}</button>
  </div>
</template>

<script>
export default {
  name: 'AccountNavigation',
  props: {
    activePage: String,
    pages: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss" scoped>
.button-group {
  justify-content: flex-start;

  .default-btn {
    justify-content: flex-start;
    &.active { background-color: rgba(0, 0, 0, 0.03) !important; }
  }

  @include mdAndBelow {
    .default-btn {
      border-radius: 8px 8px 0 0;

      &.active {
        background-color: rgba(0, 0, 0, 0.03) !important;
        border-bottom: 2px solid $primaryBlue !important;
      }
    }
  }
}
</style>
